import script from "./BrandLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandLoader.vue?vue&type=script&setup=true&lang=js"

import "./BrandLoader.vue?vue&type=style&index=0&id=b3d5de72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c68acb88b8efab7cfd13739edd187441/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d5de72"]])

export default __exports__